module.exports = __webpack_public_path__ + "img/bg_perfil.cf9f1cd1.png";